import { useEffect, useLayoutEffect } from "react"
import { useMap } from "react-leaflet"

// Kleinste Zoomstufe, auf der die Welt (256·2^z px) mindestens so breit ist wie die Karte
export function minZoomForWidth(width, snap, floor) {
  if (!(width > 0)) return floor
  const fit = Math.ceil(Math.log2(width / 256) / snap) * snap
  return Math.max(floor, fit)
}

// Reicht die Leaflet-Map nach oben (Ersatz für ref={setMap} am früheren MapContainer).
export default function MapSetup({ onMap }) {
  const map = useMap()

  useEffect(() => {
    onMap(map)
    return () => onMap(null)
  }, [map, onMap])

  // Breite Monitore: nie weiter raus, als die Welt den Ausschnitt füllt, sonst leere Weltkopien am Rand (vor dem ersten Bild)
  useLayoutEffect(() => {
    const floor = map.getMinZoom()
    const fit = () => map.setMinZoom(minZoomForWidth(map.getSize().x, map.options.zoomSnap || 1, floor))
    fit()
    map.on("resize", fit)
    return () => {
      map.off("resize", fit)
      map.setMinZoom(floor)
    }
  }, [map])

  return null
}
